<template>
  <div>
    <header class="bg-header">
      <h3 class="header-title">Comentario</h3>
    </header>
    <form>
      <div class="email">
        <label for="input-email" class="email-input-commentary">Email</label>
        <input
          type="email"
          id="input-email"
          class="email-commentary"
          placeholder="Correo"
          v-model="email"
        />
      </div>
      <div class="email">
        <label for="textarea" class="email-input-commentary">Comentario</label>
        <b-form-textarea
          id="textarea"
          v-model="text"
          placeholder="Escribe algo"
          rows="6"
          max-rows="6"
          class="text-area-form-commentary"
        ></b-form-textarea>
      </div>

      <div class="email">
        <b-button class="btn-send" @click="buildCommentary">Enviar</b-button>
      </div>
      <div style="display:flex; justify-content: center;">
        <div v-if="showAlert" class="alerta-c">
          <span>{{ alert }}</span>
        </div>
      </div>
    </form>
  </div>
</template>
<script>

export default {
  data() {
    return {
      email: "",
      text: "",
      alert: "Todos los campos son obligatorios.",
      showAlert: false,
    };
  },
  props:[
    "crearComentario"
  ],
  methods: {
    buildCommentary() {
      const validate_email = "^([\\w\\.\\-]+)?\\w+@[\\w-]+(\\.\\w+){1,}$";
      let matchEmail = new RegExp(validate_email);
      if (!matchEmail.test(this.email.trim())){
        this.showAlert = true;
        this.alert = 'Email incorrecto';
        return;
      }
      if (this.email.trim().length == 0 || this.text.trim().length == 0) {
        this.showAlert = true;
        return;
      }
      this.showAlert = false;
      let commit = {
        email: this.email.trim(),
        comentario: this.text.trim(),
      };
      try{
        this.crearComentario(commit);
      }catch(err){
        alert(err);
      }
      //this.$store.commit("setCommentary", commit);
    },
  },
};
</script>

<style scoped>
.email {
  display: grid;
  margin: 5px 5px;
  justify-content: center;
  border: none;
}
.alerta-c {
  border: 1px solid #fd5959;
  background: rgba(253, 131, 131, 0.514);
  color: #c23535;
  padding: 0.5rem;
  margin-bottom: 10px;
  width: 40%;
  font-size: 0.8rem;
  text-align: center;
}

.email-commentary {
  width: 300px;
  border: none;
  background: #eee;
  padding: 0.5rem;
}

.email-input-commentary {
  text-align: left;
  color: 052333;
  font-weight: bold;
}

.text-area-form-commentary {
  width: 300px;
  border: none;
  background: #eee;
  padding: 0.5rem;
}

.text-area-form-commentary:focus {
  background: #eee !important;
  border: none !important;
  box-shadow: none !important;
}

.btn-send {
  background: #4f52ff;
  color: #fff;
  border: none;
  font-size: 0.9rem;
  border-radius: 50px;
}

.btn-send:hover {
  background: #4f52ff;
  color: #fff;
}

.bg-header {
  background: #24c6ab !important;
}

.header-title {
  text-align: center;
  padding: 1rem 0;
}
</style>
